import React from 'react'

export const IconDashboard = (props={}) => {
	const { size=20, imgSize=16 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M8 0.336548L0.5 4.66671V15.5H15.5V4.66671L8 0.336548ZM6.75 14.25V10.0834H9.25V14.25H6.75ZM14.25 14.25H10.5V8.83336H5.5V14.25H1.75V5.38838L8 1.78005L14.25 5.38838V14.25Z" />
		</svg>
	</>
}
